export default __webpack_public_path__ + "static/media/lawn-doctors-step-1.479b75ca.jpg";